import classNames from "classnames";
import React, { ReactElement } from "react";

import styles from "./index.module.css";

/**
 * @description ページのテンプレート
 */
export const LayoutTemplate: React.FC<{
  className?: string;
  bodyElement: ReactElement;
  leftHeaderElement?: ReactElement;
  rightHeaderElement?: ReactElement;
  outsideFooterElement?: ReactElement;
  insideFooterElement?: ReactElement;
  isNoInsideContentPadding?: boolean;
}> = ({
  className,
  bodyElement,
  leftHeaderElement,
  rightHeaderElement,
  outsideFooterElement,
  insideFooterElement,
  isNoInsideContentPadding,
}) => {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.content}>
        {leftHeaderElement || rightHeaderElement ? (
          <div className={styles.header}>
            <div className={styles.leftEndContent}>{leftHeaderElement}</div>
            <div className={styles.rightEndContent}>{rightHeaderElement}</div>
          </div>
        ) : null}
        <div
          className={classNames(styles.body, {
            [styles.noPadding]: isNoInsideContentPadding,
          })}
        >
          {bodyElement}
        </div>
        {insideFooterElement ? (
          <div className={styles.footer}>{insideFooterElement}</div>
        ) : null}
      </div>
      {outsideFooterElement}
    </div>
  );
};
